export default __webpack_public_path__ + "static/media/kuliner.61d24e0f.png";